(function () {
  const PHRASES = [
    'Search for saree',
    'Search for lehenga',
    'Search for gown',
    'Search for kurti',
    'Search for anarkali',
    'Search for plazo suit',
  ];
  const TYPE_SPEED = 85;
  const DELETE_SPEED = 42;
  const PAUSE_MS = 2000;

  class TypewriterPlaceholder {
    constructor(input) {
      this.input = input;
      this.phraseIndex = 0;
      this.charIndex = 0;
      this.isDeleting = false;
      this.timer = null;
      this.running = false;
      this.staticPlaceholder = input.getAttribute('data-static-placeholder') || input.placeholder || 'Search';
      input.setAttribute('data-static-placeholder', this.staticPlaceholder);

      input.addEventListener('input', () => {
        if (this.input.value.trim()) {
          this.stop(true);
        } else {
          this.maybeStart();
        }
      });

      input.addEventListener('blur', () => window.setTimeout(() => this.maybeStart(), 60));
    }

    isVisible() {
      return !!(this.input.offsetParent || this.input.getClientRects().length);
    }

    canAnimate() {
      return !this.input.value.trim() && this.isVisible();
    }

    maybeStart() {
      if (!this.canAnimate()) return;
      this.start();
    }

    start() {
      if (this.running) return;
      this.running = true;
      if (!this.isDeleting && this.charIndex === 0) {
        this.input.placeholder = '';
      }
      this.tick();
    }

    stop(useStatic) {
      this.running = false;
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
      if (useStatic) {
        this.input.placeholder = this.staticPlaceholder;
        this.phraseIndex = 0;
        this.charIndex = 0;
        this.isDeleting = false;
      }
    }

    tick() {
      if (!this.running || !this.canAnimate()) {
        this.running = false;
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
        return;
      }

      const phrase = PHRASES[this.phraseIndex];

      if (!this.isDeleting) {
        this.input.placeholder = phrase.substring(0, this.charIndex + 1);
        this.charIndex += 1;

        if (this.charIndex >= phrase.length) {
          this.isDeleting = true;
          this.timer = window.setTimeout(() => this.tick(), PAUSE_MS);
          return;
        }

        this.timer = window.setTimeout(() => this.tick(), TYPE_SPEED);
        return;
      }

      this.charIndex -= 1;
      this.input.placeholder = phrase.substring(0, this.charIndex);

      if (this.charIndex <= 0) {
        this.isDeleting = false;
        this.phraseIndex = (this.phraseIndex + 1) % PHRASES.length;
        this.charIndex = 0;
      }

      this.timer = window.setTimeout(() => this.tick(), DELETE_SPEED);
    }
  }

  const instances = new WeakMap();

  const getInputs = () =>
    document.querySelectorAll('.avignaa-search-modal .avignaa-search-input, #search-form-mobile .avignaa-search-input');

  const initInput = (input) => {
    if (instances.has(input)) return instances.get(input);
    const instance = new TypewriterPlaceholder(input);
    instances.set(input, instance);
    return instance;
  };

  const initAll = () => {
    getInputs().forEach((input) => initInput(input));
  };

  const bindModalObservers = () => {
    document.querySelectorAll('.search_details').forEach((details) => {
      if (details.dataset.avignaaTypewriterBound === 'true') return;
      details.dataset.avignaaTypewriterBound = 'true';

      const sync = () => {
        const input = details.querySelector('.avignaa-search-input');
        if (!input) return;
        const typewriter = initInput(input);
        if (details.hasAttribute('open')) {
          window.setTimeout(() => typewriter.maybeStart(), 120);
        } else {
          typewriter.stop(false);
        }
      };

      new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });
      details.addEventListener('toggle', sync);
      if (details.hasAttribute('open')) sync();
    });

    if (document.body.dataset.avignaaMobileTypewriterBound === 'true') return;
    document.body.dataset.avignaaMobileTypewriterBound = 'true';

    new MutationObserver(() => {
      const input = document.querySelector('#search-form-mobile .avignaa-search-input');
      if (!input) return;
      const typewriter = initInput(input);
      if (document.body.classList.contains('open_search_mobile')) {
        window.setTimeout(() => typewriter.maybeStart(), 120);
      } else {
        typewriter.stop(false);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  const boot = () => {
    initAll();
    bindModalObservers();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
